import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// 申请退款
export default async function orderRefund(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/order/refund', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  return res;
}
